'use strict';

function PageDirective ($animate) {

  var link = function (scope, $el, attrs, ctrls, transclude) {
    var ctrl = ctrls[0];
    var parentCtrl = ctrls[1];

    ctrl.init(parentCtrl);

    $el.addClass('sb-nav-drawer-page');

    // add transcluded elements
    transclude(function (clone) {
      $el.append(clone);
    });

    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Helpers
    /////////////////////////////////////////////////////////////////////////////////////////////////


    scope.$on('sbDrawer:change', function(ev, delta, drawerAnimating) {
      if(delta.page.previous !== ctrl.id && delta.page.current !== ctrl.id) {
        return; // Page is not involved in change
      }

      if(drawerAnimating) {
        if(delta.page.current === ctrl.id) {
          $el.addClass('active');
          ctrl.visible = true;
        } else {
          $el.removeClass('active');
          ctrl.visible = false;
        }
      } else {
        var pos;
        // Changing to this page
        if(ctrl.id === delta.page.current) {
          pos = ctrl.getPosClass(delta.page.previous);
          $el.addClass(pos);

          // add the 'active' class
          $animate.addClass($el, 'active').then(function () {
            $el.removeClass('above below'); // remove positioning classes
          });
          ctrl.visible = true;
        } else {
          // Changing away from this page
          pos = ctrl.getPosClass(delta.page.current);
          $el.addClass(pos);

          // remove the 'active' class
          $animate.removeClass($el, 'active').then(function () {
            $el.removeClass('above below');
          });
        }
      }

    });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    bindToController: true,
    controller: 'sbNavDrawerPageController',
    controllerAs: 'ctrl',
    link: link,
    require: ['sbNavDrawerPage', '^sbNavDrawer'],
    restrict: 'EA',
    scope: {
      id: '@sbNavDrawerPage',
      index: '@', // numerical index indicating where in relation to other pages it is
      view: '=?',
    },
    transclude: true,
  };
}

module.exports = PageDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/page/PageDirective.js